import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { CarrierDepotAddComponent } from "./carrier-depot-add.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgxIntlTelInputModule } from "app/shared/projects/ngx-intl-tel-input/src/lib/ngx-intl-tel-input.module";
import { CarrierDepotService } from "../service/carrier-depot.service";
import { BusyModule } from "app/busy/busy.module";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { ValidationErrorModule } from "app/shared/validation-error/validation-error.module";
import { CarrierTypeModule } from "app/shared/carrier-type/carrier-type.module";
import { NgxLoadingModule } from "ngx-loading";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { FileDropModule } from "ngx-file-drop";

@NgModule({
  declarations: [CarrierDepotAddComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    NgbDatepickerModule,
    ValidationErrorModule,
    CarrierTypeModule,
    NgxLoadingModule.forRoot({}),
    PdfViewerModule,
    FileDropModule,
  ],
  exports: [CarrierDepotAddComponent],
  providers: [CarrierDepotService],
})
export class CarrierDepotAddModule {}
